import Input from 'components/Input';
import styled from 'styled-components';

export const InputOrder = styled(Input).attrs({
  id: "numberOrderSimple",
  stateName: "numberOrderSimple",
  name: "Pedido",
  className: "w-100",
  type: "text",
  required: true,
  placeholder: "Nº do Pedido"
})`
  width: 200px;
`;

export const InputDocument = styled(Input).attrs({
  id: "numberDocumentSimple",
  stateName: "numberDocumentSimple",
  name: "Nota Fiscal",
  className: "w-100",
  type: "text",
  required: true,
  placeholder: "Nota Fiscal"
})`
  width: 200px;
`;

export const InputNFDevolution = styled(Input).attrs({
  id: "return-invoice-number",
  stateName: "manualDevolutionInvoiceNumber",
  name: "Nº Nota Fiscal de Devolução",
  className: "w-100",
  type: "text",
  required: true,
  placeholder: "Nº Nota Fiscal de Devolução"
})`
  width: 200px;
`;
